import { motion } from "motion/react";
import { Link } from "react-router";
import {
  Code2,
  Database,
  Workflow,
  Cpu,
  ArrowRight,
  Check,
} from "lucide-react";

export function Softwareentwicklung() {
  const services = [
    {
      icon: <Code2 className="w-8 h-8" />,
      title: "Individuelle Webapplikationen",
      description:
        "Maßgeschneiderte Webanwendungen für Ihre spezifischen Geschäftsprozesse",
      examples: [
        "Kundenportale",
        "Buchungssysteme",
        "Verwaltungstools",
        "Konfiguratoren",
      ],
    },
    {
      icon: <Workflow className="w-8 h-8" />,
      title: "Prozessautomatisierung",
      description:
        "Automatisieren Sie wiederkehrende Aufgaben und sparen Sie Zeit",
      examples: [
        "API-Integrationen",
        "Workflow-Automation",
        "Datenverarbeitung",
        "E-Mail-Automation",
      ],
    },
    {
      icon: <Database className="w-8 h-8" />,
      title: "Schnittstellen & Integrationen",
      description:
        "Verbinden Sie verschiedene Systeme nahtlos miteinander",
      examples: [
        "CRM-Integration",
        "ERP-Anbindung",
        "Payment-Gateways",
        "Third-Party APIs",
      ],
    },
    {
      icon: <Cpu className="w-8 h-8" />,
      title: "MVP-Entwicklung",
      description:
        "Schnelle Entwicklung Ihres Minimum Viable Product für Startups",
      examples: [
        "Prototyp-Entwicklung",
        "Feature-Validierung",
        "Markttest-Ready",
        "Skalierbar gebaut",
      ],
    },
  ];

  const technologies = [
    "React & Next.js",
    "Node.js & Express",
    "TypeScript",
    "PostgreSQL & MongoDB",
    "Supabase & Firebase",
    "AWS & Vercel",
    "REST & GraphQL APIs",
    "Stripe & PayPal",
  ];

  const process = [
    {
      title: "Beratungsgespräch",
      description:
        "Wir verstehen Ihre Anforderungen und beraten Sie zur besten Lösung",
    },
    {
      title: "Konzept & Angebot",
      description:
        "Sie erhalten ein detailliertes Konzept mit Pflichtenheft und Aufwandsschätzung",
    },
    {
      title: "Entwicklung",
      description:
        "Agile Entwicklung mit regelmäßigen Updates und Feedback-Runden",
    },
    {
      title: "Launch & Support",
      description: "Go-Live und optionaler Wartungsvertrag",
    },
  ];

  const faq = [
    {
      question: "Was kostet individuelle Software?",
      answer:
        "Das hängt vom Umfang ab. Einfache Tools ab 3.000 €, komplexere Systeme ab 10.000 €. Nach einem Beratungsgespräch erhalten Sie ein Angebot von uns.",
    },
    {
      question: "Wie lange dauert die Entwicklung?",
      answer:
        "Je nach Komplexität 2-6 Monate. Wir arbeiten agil und liefern regelmäßig Updates.",
    },
    {
      question: "Übernimmt mutzur auch die Wartung?",
      answer:
        "Ja, wir bieten optionale Wartungsverträge an. Pauschal oder nach Aufwand.",
    },
  ];

  return (
    <div className="pt-20">
      {/* Hero */}
      <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="text-5xl lg:text-6xl mb-6">
              Individuelle Softwareentwicklung
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed">
              Wenn Standard nicht reicht: Maßgeschneiderte Lösungen für Ihre
              spezifischen Anforderungen.
            </p>
          </motion.div>
        </div>
      </section>

      {/* When You Need Custom */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl lg:text-5xl mb-6">
              Wann brauchen Sie individuelle Software?
            </h2>
            <p className="text-xl text-gray-600">
              Unser Website-Paket ist ideal für die meisten Unternehmen
            </p>
          </motion.div>
          <div className="grid lg:grid-cols-2 gap-12 max-w-5xl mx-auto">
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="bg-green-50 rounded-2xl p-8"
            >
              <h3 className="text-2xl font-semibold mb-6 text-green-900">
                Eine klassische Website reicht, wenn...
              </h3>
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <Check className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" />
                  <span className="text-green-900">
                    Sie eine Firmen-Website brauchen
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <Check className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" />
                  <span className="text-green-900">
                    Einfaches Kontaktformular ausreicht
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <Check className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" />
                  <span className="text-green-900">
                    Keine speziellen Funktionen nötig sind
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <Check className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" />
                  <span className="text-green-900">
                    Budget begrenzt ist (500 € einmalig + 99 € / Monat, jeweils zzgl.
                    gesetzlicher MwSt.)
                  </span>
                </li>
              </ul>
              <Link
                to="/angebot"
                className="inline-flex items-center gap-2 mt-6 text-green-900 hover:text-green-700"
              >
                Zum Standard-Angebot
                <ArrowRight className="w-4 h-4" />
              </Link>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="bg-black text-white rounded-2xl p-8"
            >
              <h3 className="text-2xl font-semibold mb-6">
                Individuelle Software brauchen Sie, wenn...
              </h3>
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <ArrowRight className="w-6 h-6 flex-shrink-0 mt-0.5" />
                  <span>Sie spezielle Geschäftsprozesse abbilden müssen</span>
                </li>
                <li className="flex items-start gap-3">
                  <ArrowRight className="w-6 h-6 flex-shrink-0 mt-0.5" />
                  <span>Nutzer-Accounts und Login nötig sind</span>
                </li>
                <li className="flex items-start gap-3">
                  <ArrowRight className="w-6 h-6 flex-shrink-0 mt-0.5" />
                  <span>Systeme integriert werden müssen</span>
                </li>
                <li className="flex items-start gap-3">
                  <ArrowRight className="w-6 h-6 flex-shrink-0 mt-0.5" />
                  <span>Sie ein Startup mit einer Web-App-Idee sind</span>
                </li>
              </ul>
              <Link
                to="#kontakt"
                className="inline-flex items-center gap-2 mt-6 text-white hover:text-gray-300"
              >
                Beratung anfragen
                <ArrowRight className="w-4 h-4" />
              </Link>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Services */}
      <section className="py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl lg:text-5xl mb-6">Unsere Leistungen</h2>
            <p className="text-xl text-gray-600">
              Von der Idee bis zur fertigen Lösung
            </p>
          </motion.div>
          <div className="grid md:grid-cols-2 gap-8">
            {services.map((service, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-xl transition-shadow duration-300"
              >
                <div className="w-16 h-16 bg-black rounded-xl flex items-center justify-center text-white mb-6">
                  {service.icon}
                </div>
                <h3 className="text-2xl font-semibold mb-3">{service.title}</h3>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {service.description}
                </p>
                <div className="border-t border-gray-100 pt-4">
                  <div className="text-sm font-semibold text-gray-900 mb-2">
                    Beispiele:
                  </div>
                  <div className="flex flex-wrap gap-2">
                    {service.examples.map((example, idx) => (
                      <span
                        key={idx}
                        className="px-3 py-1 bg-gray-100 text-gray-700 text-sm rounded-full"
                      >
                        {example}
                      </span>
                    ))}
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Technologies */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl lg:text-5xl mb-6">Technologie-Stack</h2>
            <p className="text-xl text-gray-600">
              Moderne, bewährte Technologien
            </p>
          </motion.div>
          <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-4 max-w-5xl mx-auto">
            {technologies.map((tech, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.95 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: index * 0.05 }}
                className="bg-gray-50 p-4 rounded-xl text-center font-medium text-gray-900"
              >
                {tech}
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Process */}
      <section className="py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl lg:text-5xl mb-6">Wie ist der Ablauf?</h2>
            <p className="text-xl text-gray-600">
              Unser Prozess von Anfang bis Ende
            </p>
          </motion.div>
	          <div className="grid md:grid-cols-4 gap-8 max-w-6xl mx-auto items-stretch">
	            {process.map((step, index) => (
	              <motion.div
	                key={index}
	                initial={{ opacity: 0, y: 20 }}
	                whileInView={{ opacity: 1, y: 0 }}
	                viewport={{ once: true }}
	                transition={{ duration: 0.6, delay: index * 0.1 }}
	                className="relative h-full"
	              >
	                {index < process.length - 1 && (
	                  <div className="hidden md:block absolute top-8 left-full w-full h-0.5 bg-gray-200 -translate-x-1/2" />
	                )}
	                <div className="relative z-10 bg-white p-6 rounded-xl h-full flex flex-col">
	                  <div className="w-12 h-12 bg-black rounded-full flex items-center justify-center text-white font-bold mb-4">
	                    {index + 1}
	                  </div>
	                  <h3 className="text-lg font-semibold mb-2">{step.title}</h3>
	                  <p className="text-sm text-gray-600 leading-relaxed">
	                    {step.description}
	                  </p>
	                </div>
	              </motion.div>
	            ))}
	          </div>
        </div>
      </section>

      {/* Image Section */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <h2 className="text-4xl mb-6">
                Agile Entwicklung mit regelmäßigem Feedback
              </h2>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                Wir arbeiten iterativ und transparent. Sie bekommen regelmäßig
                Updates und können jederzeit Feedback geben. So entstehen Lösungen,
                die wirklich zu Ihren Anforderungen passen.
              </p>
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <Check className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-700">
                    Wöchentliche Updates und Demos
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <Check className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-700">
                    Direkter Draht zum Entwicklerteam
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <Check className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-700">
                    Transparente Projektdokumentation
                  </span>
                </li>
              </ul>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <div className="aspect-square rounded-2xl overflow-hidden shadow-2xl">
                <img
                  src="/images/photo-1759844197486-5b3612c7d534.webp"
                  alt="Development process"
                  className="w-full h-full object-cover"
                />
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-24 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl lg:text-5xl mb-6">Häufige Fragen</h2>
          </motion.div>
          <div className="space-y-4">
            {faq.map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="bg-white rounded-xl p-6 shadow-sm"
              >
                <h3 className="text-lg font-semibold mb-2">{item.question}</h3>
                <p className="text-gray-600 leading-relaxed">{item.answer}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section id="kontakt" className="py-24 bg-black text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-4xl lg:text-5xl mb-6">
              Lassen Sie uns über Ihr Projekt sprechen
            </h2>
            <p className="text-xl text-gray-300 mb-8">
              Kontaktieren Sie uns für ein unverbindliches Beratungsgespräch
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="mailto:kontakt@mutzur.de"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white text-black hover:bg-gray-100 transition-all duration-300"
              >
                E-Mail schreiben
              </a>
              <Link
                to="/"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 border-2 border-white text-white hover:bg-white hover:text-black transition-all duration-300"
              >
                Zurück zur Startseite
              </Link>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
